import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { iif, mergeMap, Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RoutingPathsEnum, RoutingService } from 'src/app/core/services/routing/routing.service';
import { LoanApplicationService } from 'src/app/core/services/loan-application/loan-application.service';
import { ILoanApplication } from 'src/app/core/services/loan-application/loan-application.model';
import { IFeatureEligibilityResult, MobileApiService } from 'src/app/core/services/mobile-api';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';

import { DisbursementType } from 'src/app/core/services/loan-application/disbursement/disbursement.model';
import { OrganizationUtils } from 'src/app/core/utils/organization-utils';
import { EligibilityRoutingGuard } from './eligibility-routing.guard';

/**
 * Enhancement to existing EligibilityRoutingGuard
 * EligibilityRoutingGuard only check the config, ExpediteDisbursementRoutingGuard also check the data eligibility
 */
@Injectable()
export class ExpediteDisbursementRoutingGuard extends EligibilityRoutingGuard {
	constructor(
		protected router: Router,
		protected mobileApiService: MobileApiService,
		protected loanAppService: LoanApplicationService,
		protected routingService: RoutingService
	) {
		super(router, mobileApiService, loanAppService, routingService);
	}

	canActivate(
		route: ActivatedRouteSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return super.canActivate(route);
	}

	isDataEligible(loanApp: ILoanApplication): boolean {
		return (
			OrganizationUtils.isMetaBank(loanApp.issuingOrganization) &&
			(loanApp.disbursement.disbursementType === DisbursementType.check ||
				loanApp.disbursement.disbursementType === DisbursementType.ach)
		);
	}
}
